export default __webpack_public_path__ + "static/media/bunnyhead-main.711a9737.svg";